import CharaSlider from '../common/chara_slider/main';


export default class Main{

    constructor(){
        this.slider = null;
        this._init();
    }

    _init(){
        this.slider = new CharaSlider();
    }
}